export default "__VITE_ASSET__BsvUmdyW__"